import cx from "classnames";
import { useState } from "react";

import { ConfigProvider, Tabs } from 'antd';

import { useTranslation } from "react-i18next";

import { EMPLOYEE_WORKIN_PAGE } from "../schemas/employeeWorkInSchema";
import EmployeeWorkInCalendar from "../pages/EmployeeWorkInCalendar";
import EmployeeWorkInLeaveBenefit from "../pages/EmployeeWorkInLeaveBenefit";
import EmployeeWorkInTimestamp from "../pages/EmployeeWorkInTimestamp";
import EmployeeWorkInWorkIn from "../pages/EmployeeWorkInWorkIn";
import EmployeeWorkInWorkInLocation from "../pages/EmployeeWorkInWorkInLocation";

import styles from "../styles/Employee.module.css";
import menuStyles from "../styles/EmployeeMenu.module.css";
import { useSelector } from "react-redux";
function getItem(rules, i18n_key, label, key, icon, children, type) {
  return {
    rules,
    i18n_key,
    key,
    icon,
    children,
    label,
    type,
  };
}

const EMPLOYEE_WORKIN_MENU = [
  getItem(
    EMPLOYEE_WORKIN_PAGE.TIME_STAMP,
    "Time Stamp",
    EMPLOYEE_WORKIN_PAGE.TIME_STAMP
  ),
  getItem(
    EMPLOYEE_WORKIN_PAGE.CALENDAR,
    "Calendar",
    EMPLOYEE_WORKIN_PAGE.CALENDAR
  ),
  getItem(EMPLOYEE_WORKIN_PAGE.WORKIN, "Work in", EMPLOYEE_WORKIN_PAGE.WORKIN),
  getItem(
    EMPLOYEE_WORKIN_PAGE.WORK_IN_LOCATION,
    "Work in location",
    EMPLOYEE_WORKIN_PAGE.WORK_IN_LOCATION
  ),
  getItem(
    EMPLOYEE_WORKIN_PAGE.LEAVE_BENEFIT,
    "Leave Benefit",
    EMPLOYEE_WORKIN_PAGE.LEAVE_BENEFIT
  ),
];

function EmployeeWorkInMenu({ className = "", onChange = () => { } }) {
  const [selectedKeys, setSelectedKeys] = useState([
    EMPLOYEE_WORKIN_PAGE.TIME_STAMP,
  ]);
  const { t, i18n } = useTranslation();
  const { roles } = useSelector((state) => state.company);
  const { currentEmployee } = useSelector((state) => state.employee);
  const onMenuClick = (e) => {
    const key = e.key;
    setSelectedKeys([key]);
    onChange(key);
  };

  const employeeName = i18n.language == "en" ? `${currentEmployee?.nameEn} ${currentEmployee?.surNameEn}` : `${currentEmployee?.name} ${currentEmployee?.surName}`

  return (
    <ConfigProvider
      theme={{
        components: {
          Tabs: {
            itemHoverColor: "var(--tab-color)",
            itemActiveColor: "var(--tab-color)"
          },
        },
      }}
    >
      <Tabs defaultActiveKey={selectedKeys} onChange={onMenuClick} tabBarStyle={{ justifyContent: 'space-between' }}>
        {/* {
          roles.includes("ACCESS_EMPLOYEE|WORK_IN|TIME_STAMP") &&
          <Tabs.TabPane tab={t('tab.menu.label.time-stamp')} key={EMPLOYEE_WORKIN_PAGE.TIME_STAMP}>
            <EmployeeWorkInTimestamp />
          </Tabs.TabPane>
        } */}
        {
          roles.includes("ACCESS_EMPLOYEE|WORK_IN|CALENDAR") &&
          <Tabs.TabPane tab={t('tab.menu.label.calendar')} key={[EMPLOYEE_WORKIN_PAGE.CALENDAR]} >
            <EmployeeWorkInCalendar isEmployee={true} employeeName={employeeName} />
          </Tabs.TabPane>
        }
        {
          roles.includes("ACCESS_EMPLOYEE|WORK_IN|WORK_IN") &&
          <Tabs.TabPane tab={t('tab.menu.label.work-in')} key={[EMPLOYEE_WORKIN_PAGE.WORKIN]} >
            <EmployeeWorkInWorkIn />
          </Tabs.TabPane>
        }
        {
          roles.includes("ACCESS_EMPLOYEE|WORK_IN|WORK_IN_LOCATION") &&
          <Tabs.TabPane tab={t('tab.menu.label.work-in-location')} key={[EMPLOYEE_WORKIN_PAGE.WORK_IN_LOCATION]} >
            <EmployeeWorkInWorkInLocation />
          </Tabs.TabPane>
        }
        {
          roles.includes("ACCESS_EMPLOYEE|WORK_IN|LEAVE_BENEFIT") &&
          <Tabs.TabPane tab={t('tab.menu.label.leave-benefit')} key={[EMPLOYEE_WORKIN_PAGE.LEAVE_BENEFIT]} >
            <EmployeeWorkInLeaveBenefit />
          </Tabs.TabPane>
        }
      </Tabs>
    </ConfigProvider>
  );
}

export default EmployeeWorkInMenu;
